<template>
  <div>
    <!-- Action buttons overlay -->
    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 200px;"
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <Button 
              style="text-align: left;"
              v-for="(obj, index) in getButtons(selectedRow)" 
              :key="index" 
              :label="obj.label" 
              :icon="obj.icon"
              class="p-button-text p-button-plain" 
              @click="obj.command()"
            />
          </div>
        </div> 
      </div>
    </OverlayPanel>
 
    <Toolbar class="p-mb-4">
      <template slot="left">
        <div class="switch">
          <h5 style="white-space: pre;"> All </h5>
          <InputSwitch v-model="unread" />
          <h5 style="white-space: pre;"> Unread  </h5>
        </div>
      </template>
      <template slot="right">
        <div class="switch">
          <h5 style="white-space: pre;">Show Archived Alerts </h5>
          <Checkbox v-model="archived" :binary="true" />
        </div>
        <ProgressSpinner
          v-if="processing"
          style="width:1.7rem; height:1.7rem;" 
          strokeWidth="5" 
          fill="#EEEEEE" 
          animationDuration=".5s"
        />
      </template>
    </Toolbar>
    
    <DataTable 
      :value="tempAlerts"
      :paginator="true"
      paginatorPosition="bottom"
      dataKey="id"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedRows"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Alerts"
      :scrollable="true"
      scrollHeight="320px"
    >
      <!-- frozenWidth="50px"
      :resizableColumns="true" 
      columnResizeMode="expand" -->
      <!-- <Column 
        header="Actions"
        headerStyle="width: 50px; padding: 7px 0px;"
        :frozen="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 31.85px; padding: 0px 0px; display: flex; align-items: center;"
          >
            <Button 
              icon="pi pi-ellipsis-h" 
              class="p-button-rounded p-button-text"
              @click="toggleActions($event, slotProps.data)"
            />
          </div>
        </template>
      </Column> -->
      <Column 
        field="alertDesc" 
        header="Alert Desc"
        headerStyle="width: 7em"
      >
        <template #body="slotProps">
          <div class="under_lined" @click="$emit('processAlert', slotProps.data)">
            {{ slotProps.data.alertDesc }}
          </div>
        </template>
      </Column>
      <Column 
        field="user" 
        header="User"
        headerStyle="width: 7em"
      >
        <template #body="slotProps">
          {{ slotProps.data.user && slotProps.data.user.fullName ? slotProps.data.user.fullName : '' }}
        </template>
      </Column>
      <Column 
        field="source" 
        header="Source"
        headerStyle="width: 7em"
      >
        <template #body="slotProps">
          {{ slotProps.data.source }}
        </template>
      </Column>
      <Column 
        field="dateCreated" 
        header="Date Added"
        headerStyle="width: 7em"
      >
        <template #body="slotProps">
          {{ slotProps.data.dateCreated }}
        </template>
      </Column>
      <Column 
        field="alertSeen" 
        header="Read"
        headerStyle="width: 7em"
      >
        <template #body="slotProps">
          <ToggleButton 
            @click="toggleRead(slotProps.data)"
            v-model="slotProps.data.alertSeen" 
            onLabel="Yes" 
            offLabel="No" 
            onIcon="pi pi-check" 
            offIcon="pi pi-times" 
            style="width: 100%"
            class="p-button-sm"
          />
        </template>
      </Column>
      <Column 
        field="archived" 
        header="Archived"
        headerStyle="width: 7em"
      >
        <template #body="slotProps">
          <ToggleButton 
            @click="toggleArchived(slotProps.data)"
            v-model="slotProps.data.archived" 
            onLabel="Yes" 
            offLabel="No" 
            onIcon="pi pi-check" 
            offIcon="pi pi-times" 
            style="width: 100%"
            class="p-button-sm"
          />
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import AlertService from '@/service/AlertService.js'

export default {
  props: {
    alerts: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    filters: {
      type: Object,
      required: false
    },
    processing: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    alertService: new AlertService(),
    selectedRows: [],
    selectedRow: {},
    tempAlerts: [],
    unread: false,
    archived: false
  }),
  computed: {
    getAppWindowWidth() {
      return this.$store.getters.getAppWindowWidth
    },
    getAppWindowHeight() {
      return this.$store.getters.getAppWindowHeight
    }
  },
  updated() {
    
    
    setTimeout(() => {
      this.setFirstTableRowsHeight()
    }, 100)
  },
  watch: {
    unread(val) {
      this.filterAlerts()
    },
    archived(val) {
      this.filterAlerts()
    },
    alerts() {
      setTimeout(() => {
        this.filterAlerts()
      }, 10)
    },
    getAppWindowWidth() {
      setTimeout(() => {
        this.setFirstTableRowsHeight()
      }, 100)
    },
    getAppWindowHeight() {
      setTimeout(() => {
        this.setFirstTableRowsHeight()
      }, 100)
    }
  },
  methods: {
    filterAlerts() {
      if (this.unread) {
        this.tempAlerts = this.alerts.filter(alert => alert.alertSeen === false)
      } else {
        this.tempAlerts = this.alerts
      }
      if (!this.archived) {
        this.tempAlerts = this.tempAlerts.filter(alert => alert.archived === false)
      }
    },
    setFirstTableRowsHeight() {
      let tablesFrom = this.$el.getElementsByClassName('p-datatable-thead')
      let tablesTo = this.$el.getElementsByClassName('p-datatable-tbody')
      // 

      for (let i = 0; i < tablesFrom.length; i ++) {
        tablesFrom[i].children[0].children.forEach((column, j) => {
          let columnStyles = window.getComputedStyle(column)

          // 
          // 
          
          tablesTo[i].children[0].children[j].style.width = columnStyles.getPropertyValue('width')

        })
      }

      // let tables = this.$el.getElementsByClassName('p-datatable-tbody')
      // 
      // 

      // if (tables && tables.length >= 2) {
      //   let tableFrom = tables[tables.length - 1], tableTo = tables[tables.length - 2]
      //   
        
      //   if (tableFrom && tableTo) {
      //     let rows = tableFrom.children

      //     if (rows && rows.length) {

      //       for (let i = 0; i < rows.length; i++) {
      //         let properties = rows[i].getBoundingClientRect()

      //         if (properties && tableTo.children[i]) {
      //           tableTo.children[i].style.height = properties.height.toString() + 'px'
      //         }

      //       }
      //     }
      //   }
      // }
    },
    toggleArchived(alert) {
      setTimeout(() => {
        // 
        
        this.alertService
          .updateAlert(alert.id, { archived: alert.archived })
          .then(data => {
            this.$emit('updateAlert', alert)
          })
          .catch(error => {
            this.$emit('updateAlert', {
              ...alert,
             archived: !alert.archived
            })

            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating alert.",
              life: 5000,
            })
          })
      }, 1)
    },
    toggleRead(alert) {
      setTimeout(() => {
      //   
        
        this.alertService
          .updateAlert(alert.id, { alertSeen: alert.alertSeen })
          .then(data => {
            this.$emit('updateAlert', alert)
          })
          .catch(error => {
            this.$emit('updateAlert', {
              ...alert,
              alertSeen: !alert.alertSeen
            })

            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating alert.",
              life: 5000,
            })
          })
      }, 1)
    },
    getButtons(data) {
      let buttons = [
				{
					label: 'Open Linked Record',
					icon: 'pi pi-info-circle',
					command: () => {
            this.$refs.opActions.hide()
            this.$emit('processAlert', data)
					}
				},
				{
					label: 'Toggle Archived',
					icon: 'pi pi-inbox',
					command: () => {
            this.$refs.opActions.hide()
						this.toggleArchived({
              ...data,
              archived: !data.archived
            })
					}
        },
				{
					label: 'Toggle Read',
					icon: 'pi pi-pencil',
					command: () => {
            this.$refs.opActions.hide()
						this.toggleRead({
              ...data,
              alertSeen: !data.alertSeen
            })
					}
        }
      ]

      return buttons
    }, 
    toggleActions(event, data) {
      this.selectedRow = data
      this.$refs.opActions.toggle(event);
    },
    async toggle(event) {
      this.$refs.opActions.toggle(event);
    }
  }
}
</script>

<style>

</style>